import { Tabs as ATabs } from "antd";
import type { TabsProps } from "antd";
import { ReactNode, useEffect } from "react";
import { useSearchParams } from "react-router";

type CustomTabsProps = {
  items: TabsProps["items"];
  tabName?: string;
  className?: string;
  onChange?: (e: any) => void;
  extraContent?: ReactNode;
  isUppercase?: boolean;
  isSetDefaultActive?: boolean;
  type?: "line" | "card";
  size?: "large" | "middle" | "small";
};

export const CustomTabs = ({
  items,
  tabName,
  className,
  onChange,
  extraContent,
  isUppercase = true,
  isSetDefaultActive = false,
  type = "card",
  size = "small",
}: CustomTabsProps) => {
  const name = tabName ?? "tab";
  const [searchParams, setSearchParams] = useSearchParams();
  const typeFromURL = isUppercase
    ? searchParams.get(name)?.toUpperCase()
    : searchParams.get(name);

  useEffect(() => {
    if (isSetDefaultActive) {
      const initialActive = searchParams.get(name);

      if (!initialActive) {
        const newParams = new URLSearchParams(searchParams);

        newParams.set(
          name,
          items?.[0]?.key?.toString()?.toLowerCase() as string
        );
        setSearchParams(newParams);
      }
    }
  }, [isSetDefaultActive]);

  const onChangeHandler = (key: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(name, key.toString().toLowerCase());
    setSearchParams(newParams);
    onChange && onChange(items?.find((item) => item?.key === key));
  };

  return (
    <>
      <ATabs
        activeKey={typeFromURL as string}
        items={items}
        type={type}
        size={size}
        onChange={onChangeHandler}
        className={`mt-4 ${className}`}
        tabBarExtraContent={{ right: extraContent }}
      />
    </>
  );
};
